<template>
  <v-main>
    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <v-row>
        <!-- Detail  -->
        <v-col cols="12" md="12">
          <v-row class="justify-start mb-4 px-4 mt-1">
            <h5 class="text-h5">Detail Riwayat Konsultasi Online</h5>
          </v-row>
          <!-- Infor masi  -->
          <v-card>
            <v-card-title>
              Informasi Konsultasi <br />

              <v-spacer></v-spacer>
              <!-- <v-btn
                v-if="selectedStatus.value == 0"
                variant="flat"
                color="warning"
                class="text-none"
              >
                Pending
              </v-btn>
              <v-btn
                v-else-if="selectedStatus.value == 1"
                variant="flat"
                color="purple"
                class="text-none"
              >
                In Progress
              </v-btn>
              <v-btn
                v-else-if="selectedStatus.value == 2"
                variant="flat"
                color="primary"
                class="text-none"
              >
                Completed
              </v-btn>
              <v-btn
                v-else-if="selectedStatus.value == 3"
                variant="flat"
                color="error"
                class="text-none"
              >
                Canceled
              </v-btn> -->
            </v-card-title>

            <hr />

            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <h6 class="text-caption">Dokter</h6>
                  <p>{{ informasiKonsultasi.nama_dokter }}</p>
                  <h6 class="text-caption">Pasien</h6>
                  <p>{{ informasiKonsultasi.nama_pasien }}</p>
                  <h6 class="text-caption">Email</h6>
                  <p>{{ informasiKonsultasi.email_pasien }}</p>
                  <h6 class="text-caption">Tanggal</h6>
                  <p>
                    {{ getCurrentDate(informasiKonsultasi.tanggal_konsultasi) }}
                  </p>
                </v-col>
                <v-col cols="6">
                  <h6 class="text-caption">No Telepon Dokter</h6>
                  <p>{{ informasiKonsultasi.no_telp_dokter }}</p>
                  <h6 class="text-caption">Type</h6>
                  <p>{{ informasiKonsultasi.nama_jenis_konsultasi }}</p>
                  <h6 class="text-caption">No Telepon</h6>
                  <p>{{ informasiKonsultasi.no_telp_pasien }}</p>
                  <h6 class="text-caption">Pukul</h6>
                  <p>{{ informasiKonsultasi.jam_konsultasi }}</p>
                </v-col>
              </v-row>

              <hr />

              <p class="mt-3 mb-0 text--secondary">Keluhan</p>
              <p>
                {{ informasiKonsultasi.keluhan_awal }}
              </p>
              <!-- <p class="mt-3 mb-0 text--secondary">Admin Notes</p>
              <p class="ma-0">
                {{ informasiKonsultasi?.admin_notes }}
              </p> -->
              <p class="text-caption text--secondary">
                <!-- 14 Mei 2025 - 09:00 WIB -->
              </p>
            </v-col>
          </v-card>
          <!-- Response  -->
          <v-row>
            <!-- Response to Klien -->
            <v-col cols="6">
              <v-card v-if="isShowResponse" class="mt-3 mb-10">
                <v-card-title>
                  Response to Klien<br />

                  <v-spacer></v-spacer>
                </v-card-title>
                <v-row class="px-3">
                  <v-col cols="12 px-5">
                    <v-textarea
                      v-model="textResponseKlien"
                      outlined
                      label="Tulis Response untuk Klien.."
                    ></v-textarea>

                    <div>
                      <v-row class="text-center">
                        <v-col cols="12">
                          <v-btn
                            v-if="!loadingSend"
                            color="primary"
                            class="text-none mt-0"
                            style="width: 100%"
                            @click="sendResponseKlien"
                          >
                            <v-icon left>mdi-send</v-icon>
                            Send Response Klien</v-btn
                          >
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- Response to Dokter -->
            <v-col cols="6">
              <v-card v-if="isShowResponse" class="mt-3 mb-10">
                <v-card-title>
                  Response to Doctor <br />

                  <v-spacer></v-spacer>
                </v-card-title>
                <v-row class="px-3">
                  <v-col cols="12 px-5">
                    <v-textarea
                      v-model="textResponseDoctor"
                      outlined
                      label="Tulis Response untuk Dokter.."
                    ></v-textarea>

                    <div>
                      <v-row class="text-center">
                        <v-col cols="12">
                          <v-btn
                            v-if="!loadingSendDokter"
                            color="primary"
                            class="text-none mt-0"
                            style="width: 100%"
                            @click="sendResponseDokter"
                          >
                            <v-icon left>mdi-send</v-icon>
                            Send Response Doctor</v-btn
                          >
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <!-- Actions   -->
        <v-col cols="12" md="4">
          <v-row class="justify-end mb-3 mt-1">
            <!-- <v-btn
              v-if="!openChat"
              variant="flat"
              color="info"
              class="text-none mr-2"
              @click="openChat = true"
            >
              <v-icon left>mdi-message-text-outline</v-icon>
              Open Chats
            </v-btn> -->
            <v-btn
              v-if="openChat"
              variant="flat"
              color="info"
              class="text-none mr-2"
              @click="openChat = false"
            >
              <v-icon left>mdi-message-text-outline</v-icon>
              Close Chats
            </v-btn>
            <v-btn
              v-if="!isShowResponse"
              variant="flat"
              color="info"
              class="text-none"
              @click="isShowResponse = true"
            >
              <v-icon left>mdi-whatsapp</v-icon>
              Send Response
            </v-btn>
          </v-row>
          <!-- Actions  -->
          <!-- <v-card v-if="!openChat">
            <v-card-title>
              Actions <br />

              <v-spacer></v-spacer>
            </v-card-title>

            <hr />

            <v-col cols="12">
              <p>Update Status</p>
              <v-combobox
                v-model="selectedStatus"
                label="Status"
                clearable
                dense
                outlined
                :items="items_status"
                item-text="text"
                item-value="value"
              ></v-combobox>
              <v-btn color="primary" class="text-none mb-2" style="width: 100%"
                ><v-icon left>mdi-pen</v-icon> Reschedule</v-btn
              >
              <v-btn color="error" class="text-none" style="width: 100%">
                <v-icon left>mdi-delete</v-icon>
                Cancel Consultation</v-btn
              >
            </v-col>
            <v-col cols="12">
              <v-card class="mb-10">
                <v-card-title>
                  Admin Notes<br />

                  <v-spacer></v-spacer>
                </v-card-title>
                <v-row class="px-3">
                  <v-col cols="12 px-5">
                    <v-textarea
                      v-model="textAdminNote"
                      outlined
                      label="Tulis Catatan untuk Klien.."
                    ></v-textarea>

                    <v-btn
                      color="primary"
                      class="text-none mt-0"
                      style="width: 100%"
                    >
                      <v-icon left>mdi-send</v-icon>
                      Send Catatan Klien</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-card> -->
          <!-- Chats  -->
          <v-card v-if="openChat">
            <v-card-title>
              Chat Consultation <br />

              <v-spacer></v-spacer>
            </v-card-title>

            <hr />
            <v-col cols="12" class="container-chat">
              <v-row class="px-4 my-2">
                <div class="bubble-right text-right">
                  <p class="text--secondary ma-0">Hello,</p>
                  <span class="text-caption">10:00</span>
                </div>
              </v-row>
              <v-row class="px-4 my-2">
                <div class="bubble-left text-left">
                  <p class="text--secondary ma-0">
                    Hello, how can I help you today?
                  </p>
                  <span class="text-caption">10:10</span>
                </div>
              </v-row>
              <v-row class="px-4 my-2">
                <div class="bubble-right text-right">
                  <p class="text--secondary ma-0">
                    I have some questions about the my influenza vaccine
                  </p>
                  <span class="text-caption">10:11</span>
                </div>
              </v-row>
              <v-row class="px-4 my-2">
                <div class="bubble-left text-left">
                  <p class="text--secondary ma-0">
                    Of course! What would you like to know specifically?
                  </p>
                  <span class="text-caption">10:12</span>
                </div>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
      </v-row>

      <!-- Modal -->
      <v-dialog v-model="dialogSendKlien" max-width="500px">
        <v-card>
          <v-card-title class="text-h5"
            >Apa anda akan mengirim informasi pada klien ini?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogSendKlien = false"
              >Tidak</v-btn
            >
            <v-btn color="blue darken-1" text @click="sendResponseKlienConfirm"
              >Ya</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSendDokter" max-width="500px">
        <v-card>
          <v-card-title class="text-h5"
            >Apa anda akan mengirim informasi pada dokter?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogSendDokter = false"
              >Tidak</v-btn
            >
            <v-btn color="blue darken-1" text @click="sendResponseDokterConfirm"
              >Ya</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import TelehealthService from "../services/TelehealthService";
import CommonService from "../services/CommonService";
import * as moment from "moment";

export default {
  props: {
    id: {
      type: String,
      default: "0",
    },
  },
  data: () => ({
    breadcrumbs: [
      {
        text: "Riwayat Konsultasi Online",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    isFirst: false,
    informasiKonsultasi: {},
    openChat: false,
    selectedStatus: { value: 0, text: "Pending" },
    // items_status: [
    //   { value: 0, text: "Pending" },
    //   { value: 1, text: "In Progress" },
    //   { value: 2, text: "Completed" },
    //   { value: 3, text: "Canceled" },
    // ],
    loading: true,
    isShowResponse: true,
    // textAdminNote: "",
    textResponseKlien: "",
    textResponseDoctor: `Salam dokter [nama_dokter],
Pasien dengan nama [nama_pasien] dan no HP [no_hp] mengajukan layanan [jenis_layanan] pada waktu [waktu_konsultasi]

Terima kasih.`,
    dialogSendKlien: false,
    dialogSendDokter: false,
    loadingSend: false,
    loadingSendDokter: false,
  }),
  computed: {},
  mounted() {
    this.getInvoice();
    console.log(this.selectedStatus);
  },
  methods: {
    getCurrentDate(tanggal) {
      return moment(tanggal).format("DD/MM/YYYY");
    },

    async getInvoice() {
      this.loading = true;
      TelehealthService.getInvoice(this.id)
        .then((res) => {
          this.informasiKonsultasi = res.data.data;
          console.log(this.informasiKonsultasi);
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    async sendResponseKlien() {
      this.dialogSendKlien = true;
    },

    async sendResponseKlienConfirm() {
      this.loadingSend = true;

      TelehealthService.sendResponseKlien(this.id, this.textResponseKlien)
        .then((res) => {
          this.loadingSend = false;
          this.dialogSendKlien = false;
          console.log(res);
          CommonService.showSuccessToast("Kirim Informasi berhasil");
        })
        .catch((err) => {
          this.loadingSend = false;
          this.dialogSendKlien = false;
          console.log(err);
          CommonService.showErrorToast("Kirim Informasi gagal. Coba lagi");
        });
    },

    async sendResponseDokter() {
      this.dialogSendDokter = true;
    },

    async sendResponseDokterConfirm() {
      this.loadingSendDokter = true;

      TelehealthService.sendResponseDokter(this.id, this.textResponseDoctor)
        .then((res) => {
          this.loadingSendDokter = false;
          this.dialogSendDokter = false;
          console.log(res);
          CommonService.showSuccessToast("Kirim Informasi berhasil");
        })
        .catch((err) => {
          this.loadingSendDokter = false;
          this.dialogSendDokter = false;
          console.log(err);
          CommonService.showErrorToast("Kirim Informasi gagal. Coba lagi");
        });
    },
  },
};
</script>
<style scoped>
.container-chat {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
.bubble-right {
  background-color: #e0faf3;
  padding: 10px 10px 10px 10px;
  border-radius: 10px;
  margin-bottom: 10px;
  width: auto;
  max-width: 80%;
  margin-left: auto;
  margin-right: 0;
}
.bubble-left {
  background-color: #ededed;
  padding: 10px 10px 10px 10px;
  border-radius: 10px;
  margin-bottom: 10px;
  width: auto;
  max-width: 80%;
  margin-left: 0;
  margin-right: auto;
}
</style>
